import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { FaUserClock } from "react-icons/fa";
import { HiChevronUp } from "react-icons/hi";
import { HiExclamationTriangle, HiOutlineComputerDesktop } from "react-icons/hi2";
import { IoMoon, IoSunny } from "react-icons/io5";
import { LuPalette } from "react-icons/lu";
import { RiBuilding2Line, RiCheckLine, RiMapPin2Line } from "react-icons/ri";
import Link from "next/link";
import { ProgressBarLink, useProgressNavigation } from "@/components/progress-bar";
import ProviderAvatar from "@/components/provider-avatar";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { DROPDOWN_SEARCH_THRESHOLD, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSearch, DropdownMenuSeparator, DropdownMenuSubMenu, DropdownMenuSubMenuContent, DropdownMenuSubMenuTrigger, DropdownMenuTrigger } from "@/components/ui/dropdown";
import { ANALYTICS_ROOT } from "@/config/analytics-nav";
import { analyticsConfig, settingsConfig } from "@/config/sitemap";
import { useTenant } from "@/contexts/tenant-provider";
import { useTheme } from "@/contexts/theme-provider";
import { useUser } from "@/contexts/user-provider";
import { useClockIn } from "@/hooks/use-clock-in";
import { useLocations } from "@/hooks/use-locations";
import { formatStaffName } from "@/lib/format-data";
import { sectionMenu } from "@/lib/menu-access";
import { isNativeHost } from "@/lib/native-bridge";
import { PERMISSIONS, hasPermission } from "@/lib/permissions";
import { cx } from "@/lib/tailwind-utils";
import { ClockInConfirmContent } from "./clock-in-confirm-content";
import { SectionSubMenu } from "./section-sub-menu";
import { TenantMenuItems, useSwitchTenant } from "./switch-tenant-menu";
import { useTraining } from "@/api/provider/training/training-query";
import { authService } from "@/services/auth-service";

// iPhone/iPad home-screen apps don't reliably match the display-mode query,
// but always set the non-standard navigator.standalone. The native mobile app's
// WebView matches neither, so it is detected through the native bridge.
function isInstalledApp() {
  return isNativeHost() || (navigator as Navigator & {
    standalone?: boolean;
  }).standalone === true || window.matchMedia("(display-mode: standalone)").matches;
}
export default function ProfileButton(t0) {
  const $ = _c(151);
  const {
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [locationQuery, setLocationQuery] = useState("");
  useProgressNavigation();
  const {
    currentUser,
    currentLocationId,
    updatePrimaryLocation
  } = useUser();
  const {
    tenant
  } = useTenant();
  const {
    locations,
    isLocationsLoading
  } = useLocations();
  const {
    tenants,
    currentTenant,
    currentTenantName,
    switchTo
  } = useSwitchTenant();
  let t1;
  if ($[0] !== currentUser) {
    t1 = hasPermission(currentUser, PERMISSIONS.USAGE_READ);
    $[0] = currentUser;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const canViewUsage = t1;
  const t2 = tenant?.enabledModules;
  const t3 = tenant?.subDomain;
  let settingsMenu;
  let t4;
  if ($[2] !== currentUser || $[3] !== t2 || $[4] !== t3) {
    const sectionOptions = {
      enabledModules: t2,
      tenantSubDomain: t3
    };
    settingsMenu = sectionMenu(settingsConfig, currentUser, sectionOptions);
    t4 = sectionMenu(analyticsConfig, currentUser, sectionOptions);
    $[2] = currentUser;
    $[3] = t2;
    $[4] = t3;
    $[5] = settingsMenu;
    $[6] = t4;
  } else {
    settingsMenu = $[5];
    t4 = $[6];
  }
  const analyticsMenu = t4;
  const {
    theme,
    setTheme,
    customTheme
  } = useTheme();
  const [isPwa] = useState(isInstalledApp);
  const {
    data: training
  } = useTraining();
  const trainingAvailable = !!training?.available;
  const {
    visible: showClockIn,
    needsClockIn,
    clockIn,
    clockOut,
    longClockInDurationMs,
    timeEntry,
    todayShifts
  } = useClockIn();
  const [clockDialogOpen, setClockDialogOpen] = useState(false);
  let t5;
  if ($[7] !== switchTo) {
    t5 = value => {
      setIsOpen(false);
      switchTo(value);
    };
    $[7] = switchTo;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleTenantChange = t5;
  let t6;
  if ($[9] !== updatePrimaryLocation) {
    t6 = async locationId => {
      await updatePrimaryLocation(locationId);
      setIsOpen(false);
    };
    $[9] = updatePrimaryLocation;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleLocationChange = t6;
  let t7;
  if ($[11] !== currentLocationId || $[12] !== locations) {
    let t8;
    if ($[14] !== currentLocationId) {
      t8 = loc => loc.id === currentLocationId;
      $[14] = currentLocationId;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    t7 = locations.find(t8);
    $[11] = currentLocationId;
    $[12] = locations;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const currentLocation = t7;
  let locationNeedle;
  let t8;
  if ($[16] !== locationQuery || $[17] !== locations) {
    locationNeedle = locationQuery.trim().toLowerCase();
    t8 = locationNeedle ? locations.filter(loc_0 => loc_0.name.toLowerCase().includes(locationNeedle)) : locations;
    $[16] = locationQuery;
    $[17] = locations;
    $[18] = locationNeedle;
    $[19] = t8;
  } else {
    locationNeedle = $[18];
    t8 = $[19];
  }
  const matchingLocations = t8;
  const defaultLocationId = currentUser?.primaryLocationId ?? (locations.length === 1 ? locations[0]?.id : undefined);
  if (!currentUser) {
    return null;
  }
  let t9;
  if ($[20] !== children || $[21] !== currentLocation || $[22] !== currentTenantName || $[23] !== currentUser || $[24] !== isOpen || $[25] !== locations.length) {
    t9 = children ? children : <button className="mb-4 ml-4 mr-2 flex cursor-pointer flex-row items-center gap-2 rounded-lg border border-border bg-background p-2 hover:bg-hover">{currentUser.id && <ProviderAvatar providerId={currentUser.id} size={32} />}<div className="flex flex-1 flex-col items-start overflow-hidden text-body-strong text-foreground"><div className="truncate">{formatStaffName(currentUser)}</div>{currentUser.credentials && currentUser.showCredentialsInName === false && <div className="truncate text-caption font-normal text-foreground-secondary">{currentUser.credentials}</div>}<div className="mt-1 space-y-0.5">{currentTenantName && <div className="flex w-full items-center"><RiBuilding2Line className="mr-1 h-3 w-3 flex-shrink-0 text-foreground-secondary" /><p className="truncate text-caption font-normal text-foreground-secondary">{currentTenantName}</p></div>}{currentLocation && locations.length > 1 && <div className="flex w-full items-center"><RiMapPin2Line className="mr-1 h-3 w-3 flex-shrink-0 text-muted-foreground" /><p className="truncate text-caption font-normal text-muted-foreground">{currentLocation?.name}</p></div>}</div></div><HiChevronUp className={cx("h-4 w-4 shrink-0 text-foreground-secondary transition-transform duration-200", isOpen && "rotate-180")} /></button>;
    $[20] = children;
    $[21] = currentLocation;
    $[22] = currentTenantName;
    $[23] = currentUser;
    $[24] = isOpen;
    $[25] = locations.length;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t9) {
    t10 = <DropdownMenuTrigger asChild={true}>{t9}</DropdownMenuTrigger>;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== currentUser) {
    t11 = formatStaffName(currentUser);
    $[29] = currentUser;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11) {
    t12 = <p className="text-body-strong">{t11}</p>;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== currentUser.email) {
    t13 = <p className="text-caption text-muted-foreground">{currentUser.email}</p>;
    $[33] = currentUser.email;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t12 || $[36] !== t13) {
    t14 = <div className="mb-2 px-2 pt-1">{t12}{t13}</div>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <DropdownMenuSeparator />;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== longClockInDurationMs || $[40] !== needsClockIn || $[41] !== showClockIn) {
    t16 = showClockIn && <><DropdownMenuItem className="md:hidden" onClick={() => {
        setIsOpen(false);
        setClockDialogOpen(true);
      }}><FaUserClock className="mr-2 h-4 w-4 text-foreground-secondary" /><span className="flex flex-1 items-center gap-1">{needsClockIn ? <span>{"Clock In"}</span> : <span>{"Clock Out"}</span>}{longClockInDurationMs !== null && <HiExclamationTriangle aria-label="Clocked in for more than 12 hours" className="size-4 text-status-error-text" />}</span></DropdownMenuItem><DropdownMenuSeparator className="md:hidden" /></>;
    $[39] = longClockInDurationMs;
    $[40] = needsClockIn;
    $[41] = showClockIn;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== currentLocationId || $[44] !== handleLocationChange || $[45] !== isLocationsLoading || $[46] !== locationNeedle || $[47] !== locationQuery || $[48] !== locations.length || $[49] !== matchingLocations) {
    t17 = locations.length > 1 && <><DropdownMenuSubMenu onOpenChange={open => !open && setLocationQuery("")}><DropdownMenuSubMenuTrigger className="w-full"><div className="flex w-full items-center justify-between"><div className="flex items-center"><RiMapPin2Line className="mr-2 h-4 w-4 text-muted-foreground" /><span>Switch Location</span></div></div></DropdownMenuSubMenuTrigger><DropdownMenuSubMenuContent className="ml-2 max-h-[400px] w-56 overflow-y-auto">{locations.length > DROPDOWN_SEARCH_THRESHOLD && <DropdownMenuSearch value={locationQuery} onChange={setLocationQuery} placeholder="Search locations" />}<DropdownMenuLabel className="py-1">Available Locations</DropdownMenuLabel>{!locationNeedle && <DropdownMenuItem onClick={() => handleLocationChange(null)} className={cx("flex items-center justify-between", currentLocationId === null && "font-medium")}><span className="flex-1 truncate">All Available Locations</span>{currentLocationId === null && <RiCheckLine className="ml-2 h-4 w-4 text-foreground" />}</DropdownMenuItem>}{isLocationsLoading ? <div className="px-2 py-2 text-body text-muted-foreground">Loading locations...</div> : matchingLocations.length === 0 ? <div className="px-2 py-2 text-body text-muted-foreground">No locations found</div> : matchingLocations.map(location => <DropdownMenuItem key={location.id} onClick={() => handleLocationChange(location.id)} className={cx("flex items-center justify-between", currentLocationId === location.id && "font-medium")}><span className="flex-1 truncate">{location.name}</span>{currentLocationId === location.id && <RiCheckLine className="ml-2 h-4 w-4 text-foreground" />}</DropdownMenuItem>)}</DropdownMenuSubMenuContent></DropdownMenuSubMenu></>;
    $[43] = currentLocationId;
    $[44] = handleLocationChange;
    $[45] = isLocationsLoading;
    $[46] = locationNeedle;
    $[47] = locationQuery;
    $[48] = locations.length;
    $[49] = matchingLocations;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== currentTenant || $[52] !== handleTenantChange || $[53] !== tenants) {
    t18 = tenants.length > 1 && <><DropdownMenuSubMenu><DropdownMenuSubMenuTrigger className="w-full"><div className="flex w-full items-center justify-between"><div className="flex items-center"><RiBuilding2Line className="mr-2 h-4 w-4 text-foreground-secondary" /><span>Switch Tenant</span></div></div></DropdownMenuSubMenuTrigger><DropdownMenuSubMenuContent className="z-[999] ml-2 max-h-[400px] w-56 overflow-y-auto"><TenantMenuItems tenants={tenants} currentTenant={currentTenant} onSelect={handleTenantChange} /></DropdownMenuSubMenuContent></DropdownMenuSubMenu><DropdownMenuSeparator /></>;
    $[51] = currentTenant;
    $[52] = handleTenantChange;
    $[53] = tenants;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  let t19;
  if ($[55] !== customTheme || $[56] !== theme) {
    t19 = customTheme ? <LuPalette className="mr-2 h-4 w-4 text-muted-foreground" /> : theme === "dark" ? <IoMoon className="mr-2 h-4 w-4 text-muted-foreground" /> : theme === "light" ? <IoSunny className="mr-2 h-4 w-4 text-muted-foreground" /> : <HiOutlineComputerDesktop className="mr-2 h-4 w-4 text-muted-foreground" />;
    $[55] = customTheme;
    $[56] = theme;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  let t20;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span>Theme</span>;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  let t21;
  if ($[59] !== t19) {
    t21 = <DropdownMenuSubMenuTrigger className="w-full"><div className="flex w-full items-center justify-between"><div className="flex items-center">{t19}{t20}</div></div></DropdownMenuSubMenuTrigger>;
    $[59] = t19;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  if ($[61] !== setTheme) {
    t22 = () => setTheme("light");
    $[61] = setTheme;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  const t23 = !customTheme && theme === "light" && "font-medium";
  let t24;
  if ($[63] !== t23) {
    t24 = cx("flex items-center justify-between", t23);
    $[63] = t23;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  let t25;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="flex items-center"><IoSunny className="mr-2 h-4 w-4" /><span>Light</span></div>;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== customTheme || $[67] !== theme) {
    t26 = !customTheme && theme === "light" && <RiCheckLine className="ml-2 h-4 w-4 text-foreground" />;
    $[66] = customTheme;
    $[67] = theme;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] !== t22 || $[70] !== t24 || $[71] !== t26) {
    t27 = <DropdownMenuItem onClick={t22} className={t24}>{t25}{t26}</DropdownMenuItem>;
    $[69] = t22;
    $[70] = t24;
    $[71] = t26;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== setTheme) {
    t28 = () => setTheme("dark");
    $[73] = setTheme;
    $[74] = t28;
  } else {
    t28 = $[74];
  }
  const t29 = !customTheme && theme === "dark" && "font-medium";
  let t30;
  if ($[75] !== t29) {
    t30 = cx("flex items-center justify-between", t29);
    $[75] = t29;
    $[76] = t30;
  } else {
    t30 = $[76];
  }
  let t31;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="flex items-center"><IoMoon className="mr-2 h-4 w-4" /><span>Dark</span></div>;
    $[77] = t31;
  } else {
    t31 = $[77];
  }
  let t32;
  if ($[78] !== customTheme || $[79] !== theme) {
    t32 = !customTheme && theme === "dark" && <RiCheckLine className="ml-2 h-4 w-4 text-foreground" />;
    $[78] = customTheme;
    $[79] = theme;
    $[80] = t32;
  } else {
    t32 = $[80];
  }
  let t33;
  if ($[81] !== t28 || $[82] !== t30 || $[83] !== t32) {
    t33 = <DropdownMenuItem onClick={t28} className={t30}>{t31}{t32}</DropdownMenuItem>;
    $[81] = t28;
    $[82] = t30;
    $[83] = t32;
    $[84] = t33;
  } else {
    t33 = $[84];
  }
  let t34;
  if ($[85] !== setTheme) {
    t34 = () => setTheme("system");
    $[85] = setTheme;
    $[86] = t34;
  } else {
    t34 = $[86];
  }
  const t35 = !customTheme && theme === "system" && "font-medium";
  let t36;
  if ($[87] !== t35) {
    t36 = cx("flex items-center justify-between", t35);
    $[87] = t35;
    $[88] = t36;
  } else {
    t36 = $[88];
  }
  let t37;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <div className="flex items-center"><HiOutlineComputerDesktop className="mr-2 h-4 w-4" /><span>System</span></div>;
    $[89] = t37;
  } else {
    t37 = $[89];
  }
  let t38;
  if ($[90] !== customTheme || $[91] !== theme) {
    t38 = !customTheme && theme === "system" && <RiCheckLine className="ml-2 h-4 w-4 text-foreground" />;
    $[90] = customTheme;
    $[91] = theme;
    $[92] = t38;
  } else {
    t38 = $[92];
  }
  let t39;
  if ($[93] !== t34 || $[94] !== t36 || $[95] !== t38) {
    t39 = <DropdownMenuItem onClick={t34} className={t36}>{t37}{t38}</DropdownMenuItem>;
    $[93] = t34;
    $[94] = t36;
    $[95] = t38;
    $[96] = t39;
  } else {
    t39 = $[96];
  }
  let t40;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <DropdownMenuSeparator />;
    $[97] = t40;
  } else {
    t40 = $[97];
  }
  let t41;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <ProgressBarLink href="/settings/preferences"><DropdownMenuItem className="flex items-center"><LuPalette className="mr-2 h-4 w-4" /><span>View All Themes</span></DropdownMenuItem></ProgressBarLink>;
    $[98] = t41;
  } else {
    t41 = $[98];
  }
  let t42;
  if ($[99] !== t27 || $[100] !== t33 || $[101] !== t39) {
    t42 = <DropdownMenuSubMenuContent className="ml-2 max-h-[400px] w-48 overflow-y-auto">{t27}{t33}{t39}{t40}{t41}</DropdownMenuSubMenuContent>;
    $[99] = t27;
    $[100] = t33;
    $[101] = t39;
    $[102] = t42;
  } else {
    t42 = $[102];
  }
  let t43;
  if ($[103] !== t21 || $[104] !== t42) {
    t43 = <DropdownMenuSubMenu>{t21}{t42}</DropdownMenuSubMenu>;
    $[103] = t21;
    $[104] = t42;
    $[105] = t43;
  } else {
    t43 = $[105];
  }
  let t44;
  if ($[106] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <DropdownMenuSeparator />;
    $[106] = t44;
  } else {
    t44 = $[106];
  }
  let t45;
  if ($[107] !== canViewUsage) {
    t45 = canViewUsage && <ProgressBarLink href="/usage"><DropdownMenuItem>Usage</DropdownMenuItem></ProgressBarLink>;
    $[107] = canViewUsage;
    $[108] = t45;
  } else {
    t45 = $[108];
  }
  let t46;
  if ($[109] !== settingsMenu) {
    t46 = <SectionSubMenu name="Settings" route="/settings" menu={settingsMenu} />;
    $[109] = settingsMenu;
    $[110] = t46;
  } else {
    t46 = $[110];
  }
  let t47;
  if ($[111] !== analyticsMenu) {
    t47 = <SectionSubMenu name="Analytics" route={ANALYTICS_ROOT} menu={analyticsMenu} />;
    $[111] = analyticsMenu;
    $[112] = t47;
  } else {
    t47 = $[112];
  }
  let t48;
  if ($[113] !== trainingAvailable) {
    t48 = trainingAvailable && <ProgressBarLink href="/training"><DropdownMenuItem>Training</DropdownMenuItem></ProgressBarLink>;
    $[113] = trainingAvailable;
    $[114] = t48;
  } else {
    t48 = $[114];
  }
  let t49;
  if ($[115] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <ProgressBarLink href="/referrals"><DropdownMenuItem>Refer a Clinic</DropdownMenuItem></ProgressBarLink>;
    $[115] = t49;
  } else {
    t49 = $[115];
  }
  let t50;
  let t51;
  if ($[116] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <Link href="https://docs.decodahealth.com" target="_blank" rel="noopener noreferrer"><DropdownMenuItem>Knowledge Base</DropdownMenuItem></Link>;
    t51 = <DropdownMenuSeparator />;
    $[116] = t50;
    $[117] = t51;
  } else {
    t50 = $[116];
    t51 = $[117];
  }
  let t52;
  if ($[118] !== isPwa) {
    t52 = isPwa && <DropdownMenuItem onClick={_temp}>Refresh Page</DropdownMenuItem>;
    $[118] = isPwa;
    $[119] = t52;
  } else {
    t52 = $[119];
  }
  let t53;
  if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <Link href="/login" onClick={_temp2}><DropdownMenuItem className="text-status-error-text">Sign out</DropdownMenuItem></Link>;
    $[120] = t53;
  } else {
    t53 = $[120];
  }
  let t54;
  if ($[121] !== t14 || $[122] !== t16 || $[123] !== t17 || $[124] !== t18 || $[125] !== t43 || $[126] !== t45 || $[127] !== t46 || $[128] !== t47 || $[129] !== t48 || $[130] !== t52) {
    t54 = <DropdownMenuContent side="top" align="start" className="z-[999] w-52">{t14}{t15}{t16}{t17}{t18}{t43}{t44}{t45}{t46}{t47}{t48}{t49}{t50}{t51}{t52}{t53}</DropdownMenuContent>;
    $[121] = t14;
    $[122] = t16;
    $[123] = t17;
    $[124] = t18;
    $[125] = t43;
    $[126] = t45;
    $[127] = t46;
    $[128] = t47;
    $[129] = t48;
    $[130] = t52;
    $[131] = t54;
  } else {
    t54 = $[131];
  }
  let t55;
  if ($[132] !== isOpen || $[133] !== t10 || $[134] !== t54) {
    t55 = <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>{t10}{t54}</DropdownMenu>;
    $[132] = isOpen;
    $[133] = t10;
    $[134] = t54;
    $[135] = t55;
  } else {
    t55 = $[135];
  }
  let t56;
  if ($[136] !== clockDialogOpen || $[137] !== clockIn || $[138] !== clockOut || $[139] !== currentUser.id || $[140] !== defaultLocationId || $[141] !== isLocationsLoading || $[142] !== locations || $[143] !== needsClockIn || $[144] !== showClockIn || $[145] !== timeEntry?.startTime || $[146] !== todayShifts) {
    t56 = showClockIn && <Dialog open={clockDialogOpen} onOpenChange={setClockDialogOpen}><DialogContent className="max-w-sm"><DialogTitle className="sr-only">{needsClockIn ? "Clock in" : "Are you sure you want to clock out?"}</DialogTitle><div className="p-4"><ClockInConfirmContent mode={needsClockIn ? "in" : "out"} todayShifts={todayShifts} clockedInAt={timeEntry?.startTime} userId={currentUser?.id} locations={needsClockIn && !defaultLocationId ? locations : undefined} locationsLoading={isLocationsLoading} onClockIn={locationId_0 => {
            const effectiveLocationId = locationId_0 ?? defaultLocationId;
            if (!effectiveLocationId) {
              return;
            }
            clockIn(effectiveLocationId);
            setClockDialogOpen(false);
          }} onClockOut={() => {
            clockOut();
            setClockDialogOpen(false);
          }} onCancel={() => setClockDialogOpen(false)} /></div></DialogContent></Dialog>;
    $[136] = clockDialogOpen;
    $[137] = clockIn;
    $[138] = clockOut;
    $[139] = currentUser.id;
    $[140] = defaultLocationId;
    $[141] = isLocationsLoading;
    $[142] = locations;
    $[143] = needsClockIn;
    $[144] = showClockIn;
    $[145] = timeEntry?.startTime;
    $[146] = todayShifts;
    $[147] = t56;
  } else {
    t56 = $[147];
  }
  let t57;
  if ($[148] !== t55 || $[149] !== t56) {
    t57 = <>{t55}{t56}</>;
    $[148] = t55;
    $[149] = t56;
    $[150] = t57;
  } else {
    t57 = $[150];
  }
  return t57;
}
async function _temp2() {
  return await authService.logout();
}
function _temp() {
  return window.location.reload();
}